export default __webpack_public_path__ + "static/media/icon-ci-anverso.46ded5b1.svg";